module.exports = __webpack_public_path__ + "img/DC-appointments-plan.1151187e.svg";